import { Navigate, useParams } from "react-router-dom";
import { getLmsCourseOverviewRoute } from "@/components/lms/lms.utils";

export default function LmsScormPlayer() {
  const { courseId } = useParams<{ courseId: string }>();

  return (
    <Navigate
      to={
        courseId
          ? getLmsCourseOverviewRoute("learner", courseId)
          : "/kaerdemy/learner/courses"
      }
      replace
    />
  );
}
